module.exports = __webpack_public_path__ + "static/media/1120.6090866b.png";